<template>
  <keep-alive>
    <component v-if="!isLoadingDetail" :is="componentSelected" :detail="detail" />
    <div v-else class="row justify-content-center msstatus__tracking--icon mt-4">
      <b-spinner variant="secondary"></b-spinner>
    </div>
  </keep-alive>
</template>

<script>
import ShipmentTrackingAirOcean from './ShipmentTrackingAirOcean.vue'
import ShipmentTrackingLand from './ShipmentTrackingLand.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ShipmentTracking',
  components: {
    ShipmentTrackingAirOcean,
    ShipmentTrackingLand
  },
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      isLoadingDetail: 'shipment/isLoading'
    }),
    componentSelected () {
      if (this.detail) {        
        if (this.detail.freightMode === 'LAND') {
          return ShipmentTrackingLand
        }
        return ShipmentTrackingAirOcean
      }
      return null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/ShipmentTracking.vue